// İSG Portal — liste tablolarında satırın birincil "aç" bağlantısı (S34-1 A2). Her `web-expert`
// liste sayfası aynı sınıf dizisini KOPYALA-YAPIŞTIR ediyordu (`font-medium text-primary
// hover:underline focus-visible:…`, bkz. `PermitsListPage.tsx`, `ContractorsListPage.tsx`,
// `TrainingsListPage.tsx`, `CompaniesPage.tsx`, `RolesPage.tsx`, `DepartmentReviewQueuePage.tsx`,
// `RiskAssessmentsListPage.tsx`, `DashboardPage.tsx` — ve `DocumentTypesListPage.tsx` YANLIŞ
// sınıflarla, `text-fg`). Tek yerden bakım için tek bileşen. `react-router-dom`'un `Link`'i
// üstünde ince bir kabuk — `Breadcrumb.tsx` ile aynı emsal (`shared`'ın `peerDependencies`'inde
// zaten var). Tüm `Link` prop'larını (`to`, `state`, `title`, …) aynen taşır; ek/özel
// düzen sınıfları (`block`, `line-clamp-2`…) çağıran taraf `className`'e ekler (`cn` ile
// birleştirilir, çakışma yok).

import type { ComponentProps } from 'react';
import { Link } from 'react-router-dom';
import { cn } from './cn';

export type TableLinkProps = ComponentProps<typeof Link>;

export function TableLink({ className, children, ...props }: TableLinkProps) {
  return (
    <Link
      className={cn(
        'font-medium text-primary hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
        className,
      )}
      {...props}
    >
      {children}
    </Link>
  );
}
